import React from 'react';
import propTypes from 'prop-types';
import { Alert as Alert$1, Flex, Stack, HStack, AlertTitle, AlertDescription } from '@chakra-ui/react';
import { InfoIcon, AlertCircleIcon, CheckCircleIcon, XCircleIcon } from '@outdoorly/icons';
import { Text } from '@outdoorly/text';
import { Button, ODCloseButton } from '@outdoorly/button';

var Alert = function Alert(_ref) {
  var actions = _ref.actions,
    title = _ref.title,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'subtle' : _ref$variant,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? 'info' : _ref$status,
    description = _ref.description,
    onClose = _ref.onClose;
  var Icon = InfoIcon;
  switch (status) {
    case 'error':
      Icon = XCircleIcon;
      break;
    case 'success':
      Icon = CheckCircleIcon;
      break;
    case 'warning':
      Icon = AlertCircleIcon;
      break;
    case 'info':
      Icon = InfoIcon;
      break;
  }

  // Set all colors to white if visibility when using the solid variant
  var color;
  if (variant === 'solid') color = 'scheme.bgPrimary';
  return /*#__PURE__*/React.createElement(Alert$1, {
    status: status,
    variant: variant,
    borderRadius: "lg"
    // Increase border left width to increase size of accent only with accent variant
    ,
    borderLeftWidth: variant === 'left-accent' ? 8 : 0
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: 3
  }, title && /*#__PURE__*/React.createElement(HStack, null, /*#__PURE__*/React.createElement(Icon, {
    width: 6,
    height: 6,
    color: color
  }), /*#__PURE__*/React.createElement(AlertTitle, null, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "500",
    color: color,
    size: "lg"
  }, title))), /*#__PURE__*/React.createElement(Stack, {
    gap: "1"
  }, /*#__PURE__*/React.createElement(AlertDescription, null, /*#__PURE__*/React.createElement(Text, {
    color: color
  }, description)), actions && /*#__PURE__*/React.createElement(Stack, {
    direction: "row"
  }, actions.primary && /*#__PURE__*/React.createElement(Button, {
    variant: "link",
    color: variant === 'solid' ? 'scheme.textPrimaryInverse' : 'scheme.textPrimary',
    onClick: actions.primary.onClick
  }, actions.primary.label), actions.secondary && /*#__PURE__*/React.createElement(Button, {
    variant: "link",
    color: variant === 'solid' ? 'scheme.textPrimaryInverse' : 'scheme.textPrimary',
    onClick: actions.secondary.onClick
  }, actions.secondary.label)))), !!onClose && /*#__PURE__*/React.createElement(ODCloseButton, {
    position: "absolute",
    right: "8px",
    top: "8px",
    size: "sm",
    onClick: onClose
  })));
};
Alert.propTypes = {
  actions: propTypes.shape({
    primary: propTypes.shape({
      label: propTypes.string.isRequired,
      onClick: propTypes.func.isRequired
    }),
    secondary: propTypes.shape({
      label: propTypes.string.isRequired,
      onClick: propTypes.func.isRequired
    })
  }),
  title: propTypes.string.isRequired,
  variant: propTypes.oneOf(['subtle', 'solid', 'left-accent']),
  status: propTypes.oneOf(['error', 'success', 'warning', 'info']),
  description: propTypes.string,
  onClose: propTypes.func
};

export { Alert };
